import React from 'react';
import {createRoot} from 'react-dom/client';
import {ConfigProvider} from 'antd';
import {BrowserRouter} from 'react-router-dom';
import {antdTheme} from '@acuwize/shared';
import '@acuwize/shared/tokens.scss';
// Editor's stylesheet only ships side-effect-loaded by editor's standalone
// main.jsx. Portal-embedded mode (<TenetEditor> imported directly) misses
// it — that's why the editor inside portal looked unstyled. Editor exposes
// the file as a subpath export (editor/package.json `exports`); importing
// it here loads the full 1500-line stylesheet once for the whole portal
// app. Comments at editor/src/index.js spell out this exact contract.
import '@acuwize/openapi-editor/styles.scss';
import './styles.scss';
import App from './App';

const container = document.getElementById('portal_root');
const root = createRoot(container);
root.render(
    <BrowserRouter>
        <ConfigProvider theme={antdTheme}>
            <App />
        </ConfigProvider>
    </BrowserRouter>
);
